import React from 'react'
import AccountSettings from 'src/app/AccountSettings/AccountSettings'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountSettingsRouteProps } from 'src/navigation/routeProps'

const AccountSettingsAppRoute: AppRoute = {
  id: AppLocation.AccountSettings,
  routeProps: accountSettingsRouteProps,
  component: <AccountSettings />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountSettingsAppRoute
